import React from "react";
import styled from "styled-components";

import { device } from "../../../../../../utils";
import { Heading1, Paragraph } from "../../../../atoms";
import SwitzerlandImageDesktop from "./switzerland-desktop.webp";
import SwitzerlandImageMobile from "./switzerland-mobile.webp";
import SwitzerlandLogo from "./switzerland-logo.svg";
import QrCodeImage from "./swiss-qr-code.svg";
import { AppStore } from "../../../../../molecules/app-store";
import { config } from "../../../../../../config";

const Switzerland = styled("div")`
  display: flex;
  height: 589px;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  margin: auto;
  margin-bottom: 37px;
  margin-top: 37px;
  border-radius: 7px;
  overflow: hidden;
  flex-direction: column;
  @media ${device.tablet} {
    flex-direction: row;
    box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.13);
  }
  @media ${device.laptop} {
    margin-bottom: 52px;
  }
  @media ${device.desktop} {
    margin-top: 0;
  }
`;

const LogoSection = styled("div")`
  width: 100%;
  height: 260px;
  border-radius: 8px 8px 0px 0px;
  align-content: center;
  align-items: center;
  background-size: cover;
  background-image: url(${SwitzerlandImageMobile});
  @media ${device.tablet} {
    border-radius: 0;
    background-image: url(${SwitzerlandImageDesktop});
    max-width: 445px;
    min-width: 50%;
    flex-shrink: 0;
    align-self: stretch;
    width: unset;
    height: unset;
  }
`;

const Logo = styled("div")`
  background-image: url(${SwitzerlandLogo});
  background-size: cover;
  width: 180px;
  height: 180px;
  margin: auto;
  @media ${device.tablet} {
    width: 204px;
    height: 204px;
    position: sticky;
    top: 100%;
    left: 100%;
    margin-right: 12px;
    margin-bottom: 12px;
  }
`;

const Content = styled("div")`
  display: flex;
  padding: 20px 16px;
  flex-direction: column;
  align-items: flex-start;
  flex: 1 0 0;
  align-self: stretch;
  justify-content: center;
  width: 100%;
  background-color: ${({ theme }) => theme.colours.background.white};
  @media ${device.tablet} {
    padding: 80px 16px;
  }
  @media ${device.laptop} {
    padding: 142px 48px;
    max-width: 475px;
  }
`;

const MainSection = styled("div")`
  display: flex;
  flex-direction: column;
`;

const H1 = styled(Heading1)`
  font-size: 24px;
  text-align: center;
  @media ${device.tablet} {
    font-size: 30px;
  }
`;

const InfoSection = styled("div")`
  display: flex;
  flex-direction: column;
  gap: 20px;
  align-items: center;
  padding: 0px 4px;
  @media ${device.laptop} {
    padding: 0px 8px;
  }
`;

const Info = styled("div")`
  width: 100%;
  display: flex;
  justify-content: center;
  gap: 13px;
`;

const QrCode = styled("img")`
  width: 63px;
  height: 63px;
  background-size: cover;
  @media ${device.mobileS} {
    display: none;
  }

  @media ${device.tablet} {
    width: 122px;
    height: 122px;
    display: block;
  }
`;

const AnnounceParagraph = styled(Paragraph)`
  text-align: center;
`;

const AppStoreIcons = styled(AppStore)`
  justify-content: center;
  width: 140px;
  flex-direction: column;

  > div {
    padding: 0;
    text-align: left;
  }

  a {
    display: block;
    margin: 0;
  }

  @media ${device.tablet} {
    min-width: 155px;
    min-height: 48px;
  }
`;

export const SwitzerlandPanel = (): JSX.Element => {
  return (
    <Switzerland>
      <LogoSection>
        <Logo />
      </LogoSection>
      <Content>
        <MainSection>
          <H1>
            Download the app and book expert beauty and wellness services to
            your door.
          </H1>
          <InfoSection>
            <Info>
              <AnnounceParagraph>
                Get live booking updates, access to exclusive offers, and chat
                directly to your Ruuby professional.
              </AnnounceParagraph>
            </Info>
            <Info>
              <QrCode src={QrCodeImage} />
              <AppStoreIcons adjustLink={config.adjustAppUrls.switzerland} />
            </Info>
          </InfoSection>
        </MainSection>
      </Content>
    </Switzerland>
  );
};
